import { render, staticRenderFns } from "./select-service-company.vue?vue&type=template&id=22dac27a"
import script from "./select-service-company.vue?vue&type=script&lang=js"
export * from "./select-service-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports